import { useState, useCallback } from 'react';
import api from '../services/api';

export function useMonitor() {
  const [health, setHealth] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getSystemHealth = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.get('/monitor/health');
      if (response.data.success) {
        setHealth(response.data.data);
      }
    } catch (err) {
      setError(err.message || 'Failed to fetch system health');
      console.error('Failed to get system health:', err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    health,
    loading,
    error,
    getSystemHealth,
  };
}
